import React from 'react'
import { StyleProps } from 'utilities'
import styles from './HorizontalLine.module.scss'
import cl from 'classnames'

const HorizontalLineComponent = (props: StyleProps) => {
  const {
    className,
    style
  } = props
  return (
    <div
      className={cl(styles.horizontalLine, className)}
      style={style}
    />
  )
}

const HorizontalLine = HorizontalLineComponent
export { HorizontalLine }
